import { baseUrlManagement as management } from "lib/actions/endpoints/endpoints";
import { Endpoint } from "lib/types/Endpoint";

const billing = `${management}/billing`;

export const endpointsBilling = {
  previewInvoice: (workspaceId: number) =>
    `${billing}/workspace/${workspaceId}/subscription/invoices/preview`,
  beginSubscription: (workspaceId: number) =>
    ({
      method: "POST",
      url: `${billing}/workspace/${workspaceId}/subscription/begin`,
    }) as Endpoint,
  paymentMethods: (workspaceId: number) =>
    `${billing}/workspace/${workspaceId}/customer/payment-methods`,
  subscriptionTiersList: () => `${billing}/tiers/all`,
  subscriptionTierDetails: (workspaceId: number) =>
    `${billing}/workspace/${workspaceId}/subscription/tier`,
  workspaceSubscriptionStatus: (workspaceId: number) =>
    `${billing}/workspace/${workspaceId}/subscription/status`,
  billingPortalUrl: (workspaceId: number) =>
    `${billing}/workspace/${workspaceId}/customer/portal`,
  validatePromoCode: `${billing}/promotions/validate`,
};
